module.exports = __webpack_public_path__ + "static/media/bg.1bb3c4ee.png";